<template>
  <div class="message">
    <div>
      <img :src="staticAssets.ImgObj.right_icon" alt="" />
    </div>
    <div class="font">{{TLang('缺票登记成功','my')}}</div>
  </div>
</template>

<script>
export default {
  name: "message",
  data() {
    return {};
  }
};
</script>

<style scoped lang="less">
.message {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -53px;
  margin-left: -104px;
  width: 208px;
  height: 107px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  text-align: center;
  img {
    width: 32px;
    margin-top: 24px;
  }
  .font {
    margin-top: 8px;
    color: white;
    font-size: 14px;
  }
}
</style>
